import React, { useState, useEffect, useCallback, useMemo } from 'react';
import {  Typography, Divider, Paper, Grid, Box, TextField } from '@mui/material';
import { useSnackbar } from 'notistack';
import MobileDateRangePicker from '@mui/lab/MobileDateRangePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { buildTableDataAndColumns, getConstDbFormat } from 'utils/common';
import LibrarySelect from 'components/librarySelect';
import { getIncentiveReport } from 'services/reports';
import ReactDataTableBuilder from 'components/tableBuilder'
import { useSearchParams } from 'react-router-dom';
import { parse } from 'date-fns';

const IncentiveReport = () => {
  const [searchParams] = useSearchParams();
  const defaultFilterDates = useMemo(() => {
    if( searchParams ){
      const fromString = searchParams.get('from'), toString = searchParams.get('to');
      let from, to;
      if(fromString && toString){
        try{
          from = parse(fromString, 'yyyy-MM-dd', new Date());
          to = parse(toString, 'yyyy-MM-dd', new Date());
          return [to,from]
        }catch(e){
        }
      }
    }
    return [new Date(), new Date()];
  }, [searchParams]);
  const [ filterDates, setFilterDates] = useState([...defaultFilterDates]);
  const [reportsData, setReportsData] = useState([]);
  const [selectedLibrary, setSelectedLibrary] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const [tableData, setTableData] = useState(false);


  useEffect(() => {
    const [fromDate,  toDate] = filterDates;
    if(fromDate && toDate && selectedLibrary){
      getReportData(filterDates,  selectedLibrary);
    }
  }, [filterDates, selectedLibrary]);

  const onLibrarySelected = useCallback((lib) => {
    setSelectedLibrary({...lib});
  },[]);
  

  function getReportData(filterDates,  selectedLibrary) {
    const [fromDate,  toDate] = filterDates;
    const reqData = {
      fromDate: getConstDbFormat(fromDate),
      toDate: getConstDbFormat(toDate),
      propertyId: selectedLibrary?.libraryId,
      propertyType: 'LIBRARY'
    };

    getIncentiveReport(reqData).then(({response, error}) => {
      if(response){
        setReportsData(response);
      } else {
        setReportsData([]);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  function onDateAccepted(data) {
    const [fromDate,  toDate] = data;
    if((fromDate && toDate)) {
      setFilterDates([...data]);
    }else{
      setFilterDates(null);
      enqueueSnackbar(`Select ${fromDate === null ? 'From Date' : 'To Date'}`, {variant: 'error'});
    }
  }

  function buildTableColumns() {
    const columns=[
      {name: "Description", key: "description", columnOptions: {width: 200}},
      {name: "Amount", key: "amount", columnOptions: {width: 220}},
      {name: "Date", key: "createdOn", columnOptions: {width: 140}},
    ];
    return columns;
  };

  function buildTable(data) {
    const columns = buildTableColumns(data);
    const tData = buildTableDataAndColumns(columns,data);
    setTableData({...tData});
  }

  useEffect(() => {
    if(Array.isArray(reportsData) && reportsData.length > 0){
      buildTable(reportsData);
    }else{
      setTableData({});
    }
  }, [reportsData]);
  
  const onDateError = (error) => {}
   
  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
    {/* <CardContent> */}
      <Typography component="h2" variant="h6" color="secondary" gutterBottom>
        Incentives Report
      </Typography>
      <Divider />
      <Box noValidate  sx={{ mt: 2 }} >
        <Grid container spacing={3} alignItems="center"  direction="row">
          <Grid container item xs={12} sm={12} md={12} xl={12} lg={12} sx={{ p: '0.8rem !important', ml: 2, mt:3, bgcolor: "#f3f3f3"}} rowSpacing={1}>
            {/* <Paper elevation={0} sx={{p:1, bgcolor: "#f3f3f3"}}> */}
              <Grid item xs={12} sm={12} md={12} xl={12} lg={12}  >
                <Typography variant="subtitle2"  component="div">
                Filters
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={6} xl={6} lg={6}  sx={{mt: 1.4}}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <MobileDateRangePicker
                    startText="From Date"
                    endText="To Date"
                    value={filterDates}
                    onError = {onDateError}
                    inputFormat="dd/MM/yyyy"
                    onChange={(newValue) => {
                      return newValue;
                    }}
                    onAccept={(data) => onDateAccepted(data)}
                    renderInput={(startProps, endProps) => (
                      <React.Fragment>
                        <TextField {...startProps} size="small" onKeyDown={(e) => {e.preventDefault();return false}}/>
                        <Box sx={{ mx: 1 }}> to </Box>
                        <TextField {...endProps} size="small" onKeyDown={(e) => {e.preventDefault();return false}} />
                      </React.Fragment>
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={12} md={6} xl={6} lg={6}  sx={{mt: 1.4, display: 'flex',justifyContent: {md: 'end'}}}>
                <LibrarySelect variant="outlined" onLibrarySelected={onLibrarySelected} defaultSelectId={searchParams?.get('libraryId')} />
              </Grid>
            {/* </Paper> */}
          </Grid>
          <Grid item xs={12} sm={12} md={12} xl={12} lg={12} >
            {tableData ? <ReactDataTableBuilder id="bookingsTable" minHeight={500} tableData={tableData} downloadFileName="incentives_report" /> : null}
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}

export default IncentiveReport;

